import React from "react";
import { XIcon, CheckIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { beforeItems, afterItems } from "../../data/content";
export function BeforeAfter() {
  return <section className="w-full bg-cream px-4 py-16 sm:py-20" data-id="element-82" data-mp="26k9wuh2e19bf">
      <div className="mx-auto max-w-5xl" data-id="element-83" data-mp="22lsmlono7ips">
        <SectionHeading title={<>From an Unstructured Study Routine to a <em className="text-forest" data-id="element-85" data-mp="2z9qmx82jce4h">Guided Learning Process</em></>} data-id="element-84" data-mp="22iofaiews6uw" />

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-86" data-mp="2ubfe90nz89nu">
          <div className="rounded-3xl border-2 border-red-200 bg-red-50 p-6 sm:p-8" data-id="element-87" data-mp="2u9uemwmt20j4">
            <div className="flex items-center gap-3" data-id="element-88" data-mp="2q8ip0r3xlfax">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-red-600 text-white" data-id="element-89" data-mp="2lbscgdrc51u9">
                <XIcon className="h-5 w-5" strokeWidth={3} aria-hidden="true" data-id="element-90" data-mp="1ew8394nlujfz" />
              </span>
              <h3 className="font-serif text-2xl font-bold text-red-800" data-id="element-91" data-mp="19v29d3i7kq4v">Before</h3>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-92" data-mp="176ffkhlqas25">
              {beforeItems.map(t => <li key={t} className="flex gap-3 text-[16px] leading-relaxed text-red-950" data-id="element-93" data-mp="1c4p96nrt1kln">
                  <XIcon className="mt-1 h-5 w-5 shrink-0 text-red-600" strokeWidth={2.5} aria-hidden="true" data-id="element-94" data-mp="y57iu3yv1za6" />
                  <span data-id="element-95" data-mp="132prdt8yuchn">{t}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border-2 border-cta/40 bg-emerald-50 p-6 sm:p-8" data-id="element-96" data-mp="odtlo2udtbk7">
            <div className="flex items-center gap-3" data-id="element-97" data-mp="t5utnckiog4f">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-cta text-white" data-id="element-98" data-mp="t7nz4oje8uau">
                <CheckIcon className="h-5 w-5" strokeWidth={3} aria-hidden="true" data-id="element-99" data-mp="fcddm1r1hlj5" />
              </span>
              <h3 className="font-serif text-2xl font-bold text-emerald-900" data-id="element-100" data-mp="5g0hyybxoxlr">With the Protocol Vault™</h3>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-101" data-mp="afmuf5jxu9ti">
              {afterItems.map(t => <li key={t} className="flex gap-3 text-[16px] font-medium leading-relaxed text-emerald-950" data-id="element-102" data-mp="2c40vyqsbvo64">
                  <CheckIcon className="mt-1 h-5 w-5 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-103" data-mp="27d0x3fznew0z" />
                  <span data-id="element-104" data-mp="23b60gosnx6tj">{t}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-10" data-id="element-105" data-mp="1ye5ro64fhpyq">
          <CtaButton label="I want a ready-made system" data-id="element-106" data-mp="1yarqh17i3msv" />
        </div>
      </div>
    </section>;
}